var exports = {
  "vK": "banner__4MLKbR",
  "pJ": "contributors__P06ISZ",
  "qj": "contributorLink__Oc1ZVB",
  "Pq": "contributorsList__ZhJQAs",
  "C3": "additionalLoginsList__Bo-pjQ",
  "db": "actionLink__k8uNDw",
  "DD": "title__4nxhG9",
  "hP": "actionButton__4hvjRt",
  "my": "avatar__6Y14Hs",
};

module.exports = exports;
